<template>
  <div class="wrapper">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin: auto 20px">
      <el-tab-pane  :label="$t('txmis.risk.baseSetting')" name="first"></el-tab-pane>
      <el-tab-pane  :label="$t('txmis.risk.specialSetting')" name="second"></el-tab-pane>
      <el-tab-pane  :label="$t('txmis.risk.ipSetting')" name="third"></el-tab-pane>
    </el-tabs>
    <el-button v-if="activeName == 'second'" type="primary" style="margin: auto 20px" @click="add(2)">{{$t('txmis.risk.addspecialSetting')}}</el-button>
    <el-button v-if="activeName == 'third'" type="primary" style="margin: auto 20px" @click="add(3)" >{{$t('txmis.risk.addBaseSetting')}}</el-button>
    <table-page v-show="activeName == 'first'" ref="childTable1"   @btnclick="bthClick1" :pageData="pageData1"></table-page>
    <table-page v-show="activeName == 'second'" ref="childTable2"   @btnclick="bthClick2" :pageData="pageData2"></table-page>
    <table-page v-show="activeName == 'third'" ref="childTable3"   @btnclick="bthClick3" :pageData="pageData3"></table-page>
    <UPDATE  ref="childUpdate1"  @submit="submit1" :updateData="updateData1"></UPDATE>
    <UPDATE  ref="childUpdate2"  @submit="submit2" :updateData="updateData2"></UPDATE>
    <UPDATE  ref="childUpdate3"  @submit="submit3" :updateData="updateData3"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let iprule = {"1":"ip归属地","2":"手机号码归属地","3":"省份证号码归属地"};
  let pkeyList = {}, nkeyList = {}, creditLevelList={};
  export default {
    name: 'list',
    components: {
      tablePage,
      UPDATE
    },
    created(){
        for (let i = 0; i < 16; i++) {
            pkeyList["P"+i] = "P"+i;
        }
        for (let i = 0; i < 11; i++) {
            nkeyList["N"+i] = "N"+i;
            nkeyList["A"+i] = "A"+i;
        }
        for (let i = -4; i < 11; i++) {
            creditLevelList[i] = i;
        }
    },
    mounted(){
        this.$refs.childTable1.defaultGetData({dataType:0});
        this.$refs.childTable2.defaultGetData({dataType:1});
        this.$refs.childTable3.defaultGetData();
    },
    methods: {
      handleClick(tab, event) {
          this.activeName = tab.name;
      },
      add(type){
          if (type == 2){
              this.$refs.childUpdate2.open();
          }else if (type == 3){
              this.$refs.childUpdate3.open();
          }
      },
      /*表格按钮点击事件*/
      bthClick1 (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate1.open(row);
        }
      },
      bthClick2 (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate2.open(row);
        }else if (clickName == "delete"){
            this.dataChanage(URL.riskchecktarget.delete,{id:row.id},res => {
                this.$refs.childTable2.defaultGetData({dataType:1});
                if (res.code == 0){
                    this.$refs.childUpdate2.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        }
      },
      bthClick3 (clickName, row) {
          if (clickName == "update"){
              this.$refs.childUpdate3.open(row);
          }else if (clickName == "delete"){
              this.dataChanage(URL.riskcheckrule.delete,{id:row.id},res => {
                  this.$refs.childTable3.defaultGetData();
                  if (res.code == 0){
                      this.$refs.childUpdate2.close();
                      this.$message.success("suc");
                  }else{
                      this.$message.error(res.message);
                  }
              })
          }
      },

      /*新增或跟提交数据触发事件*/
      submit1(model){
        //根据是否包含id更新还是添加
          this.dataChanage(URL.riskchecktarget.edit,model,res => {
              this.$refs.childTable1.defaultGetData({dataType:0});
              if (res.code == 0){
                  this.$refs.childUpdate1.close();
                  this.$message.success("suc");
              }else{
                  this.$message.error(res.message);
              }
          })
      },
      submit2(model){
        //根据是否包含id更新还是添加
          model.dataType = 1;
          this.dataChanage(URL.riskchecktarget.edit,model,res => {
              this.$refs.childTable2.defaultGetData({dataType:1});
              if (res.code == 0){

                  this.$refs.childUpdate2.close();
                  this.$message.success("suc");
              }else{
                  this.$message.error(res.message);
              }
          })
      },
      submit3(model){
          //根据是否包含id更新还是添加 URL.riskcheckrule.query
          this.dataChanage(URL.riskcheckrule.edit,model,res => {
              this.$refs.childTable3.defaultGetData();
              if (res.code == 0){
                  this.$refs.childUpdate3.close();
                  this.$message.success("suc");
              }else{
                  this.$message.error(res.message);
              }
          })
      },
      dataChanage(url,option,suc,fail){
          this.axios.post(url, Qs.stringify(option || {})).then(res => {
              if(suc && (typeof suc == 'function')) suc(res);
          }).catch(res => {
              if(fail && (typeof fail == 'function')) fail(res);
          })
      }
    },
    data () {
      return {
        activeName:"first",
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData1:{
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: 'dataType', field: 'dataType',hidden:true},
            { title: window.$t('txmis.risk.userType'), field: 'name',readonly:true},
            { title: window.$t('txmis.risk.pkey'), field: 'pkey',type:2,optionList:pkeyList,required:true},
            { title: window.$t('txmis.risk.nkey'), field: 'nkey',type:2,optionList:nkeyList,required:true},
            { title: 'companyId', field: 'companyId',hidden:true},
            { title: window.$t('txmis.risk.creditLevel'), field: 'creditLevel',type:2,optionList:creditLevelList},
            { title: window.$t('txmis.common.remark'), field: 'remark',textType:"textarea"},
          ]
        },
        updateData2:{
            cols:[
                { title: 'id', field: 'id',hidden:true},
                { title: 'dataType', field: 'dataType',hidden:true},
                { title: window.$t('txmis.risk.userType'), field: 'name',required:true},
                { title: window.$t('txmis.risk.utmSource'), field: 'utmSource',required:true},
                { title: window.$t('txmis.risk.utmMedium'), field: 'utmMedium',required:true},
                { title: window.$t('txmis.risk.utmCampaign'), field: 'utmCampaign',required:true},
                { title: window.$t('txmis.risk.pkey'), field: 'pkey',type:2,optionList:pkeyList,required:true},
                { title: window.$t('txmis.risk.nkey'), field: 'nkey',type:2,optionList:nkeyList,required:true},
                { title: 'companyId', field: 'companyId',hidden:true},
                { title: window.$t('txmis.common.remark'), field: 'remark',textType:"textarea"},
            ]
        },
        updateData3:{
            cols:[
                { title: 'id', field: 'id',hidden:true},
                { title: 'companyId', field: 'companyId',hidden:true},
                { title: window.$t('txmis.risk.settingTpye'), field: 'dataType',type:2,optionList:iprule,isNumber:true,required:true},
                { title: window.$t('txmis.risk.limitSetting'), field: 'rule',required:true},
                { title: window.$t('txmis.risk.pkey'), field: 'pkey',type:2,optionList:pkeyList,required:true},
                { title: window.$t('txmis.risk.nkey'), field: 'nkey',type:2,optionList:nkeyList,required:true},
                { title: window.$t('txmis.common.remark'), field: 'remark'},
            ]
        },
        /*table生成*/
        pageData1: {
          isPage:false,
          queryUrl: URL.riskchecktarget.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('txmis.risk.userType'), field: 'name'},
              { title: window.$t('txmis.risk.pkey'), field: 'pkey'},
              { title: window.$t('txmis.risk.nkey'), field: 'nkey'},
              { title: window.$t('txmis.common.remark'), field: 'remark'},
              { title: window.$t('txmis.risk.creditLevel'), field: 'creditLevel'},
              { title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('txmis.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('txmis.common.updater'), field: 'updater'},
              {field: window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-update"}
          ]
        },
        pageData2: {
              isPage:false,
              queryUrl: URL.riskchecktarget.query, //请求路径和参数
              sequence: true,
              cols: [
                  { title: window.$t('txmis.risk.userType'), field: 'name'},
                  { title: window.$t('txmis.risk.utmSource'), field: 'utmSource'},
                  { title: window.$t('txmis.risk.utmMedium'), field: 'utmMedium'},
                  { title: window.$t('txmis.risk.utmCampaign'), field: 'utmCampaign'},
                  { title: window.$t('txmis.risk.pkey'), field: 'pkey'},
                  { title: window.$t('txmis.risk.nkey'), field: 'nkey'},
                  { title: window.$t('txmis.common.remark'), field: 'remark'},
                  { title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                          return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                  { title: window.$t('txmis.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                          return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                      }},
                  { title: window.$t('txmis.common.updater'), field: 'updater'},
                  {field: window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-update"},
                  {field: window.$t('txmis.bt.delete'),title:window.$t('txmis.bt.operation'),size:"mini",click:"delete",type:"primary",icon:"el-icon-delete"}
              ]
        },
        pageData3: {
            isPage:false,
            queryUrl: URL.riskcheckrule.query, //请求路径和参数
            sequence: true,
            cols: [
                { title: window.$t('txmis.risk.settingTpye'), field: 'dataType',render:(data)=>{
                        return iprule[data];
                    }},
                { title: window.$t('txmis.risk.limitSetting'), field: 'rule'},
                { title: window.$t('txmis.risk.pkey'), field: 'pkey'},
                { title: window.$t('txmis.risk.nkey'), field: 'nkey'},
                { title: window.$t('txmis.common.remark'), field: 'remark'},
                { title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                    }},
                { title: window.$t('txmis.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                        return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                    }},
                { title: window.$t('txmis.common.updater'), field: 'updater'},
                {field: window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-update"}
            ]
        }
      }
    }
  }
</script>
